import { Injectable } from '@angular/core';

import { BehaviorSubject, from, Observable, of } from 'rxjs';

import { environment } from '@zeusm/environment';

declare const grecaptcha: any;

@Injectable()
export class RecaptchaService {
  readonly #isAlreadyInitedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    this.init();
  }

  init(): void {
    const isAlreadyInit = this.#isAlreadyInitedSubject.getValue();

    if (!isAlreadyInit) {
      const recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', `${environment.recaptchaAPIUrl}${environment.recaptchaSiteKey}`);
      recaptchaScript.setAttribute('async', 'true');
      recaptchaScript.setAttribute('defer', 'true');
      document.head.append(recaptchaScript);
      this.#isAlreadyInitedSubject.next(true);
    }
  }

  execute(): Observable<any> {
    if (grecaptcha) {
      const promise = new Promise<string>((resolve, reject) => {
        if (!grecaptcha.ready) {
          resolve('');

          return;
        }

        grecaptcha.ready(() =>
          grecaptcha.execute(environment.recaptchaSiteKey).then((token: string) => {
            resolve(token);
          }, reject),
        );
      });

      return from<any>(promise);
    } else {
      return of('');
    }
  }
}
